export default {
  buttons: {
    save: 'Salvare',
    confirm: 'Confirmare',
    cancel: 'Anulare',
  },
  confirmation: {
    title: 'Sigur doriți să sincronizați cu serviciile externe?',
  },
};
